export default function capitalizeFirstLetter(string) {
      if (string.toLowerCase() === "gift_vouchers") {
          return "Gift Vouchers"; // Capitalize "V" in "Vouchers"
      }
      return string.replace(/\b\w/g, char => char.toUpperCase());
    }

    